<template>
  <div>
    <section class="chat-section">
      <chat-search></chat-search>
    </section>
    <section class="chat-section personal-chats mb-0 d-none d-md-block">
      <ul class="chat-list">
        <chat-list-item
          v-for="chat of dataChatRoom"
          :key="chat.id"
          :chat="chat"
          :isActive="chat.id === activeChatId"
          @click.native="selectChat(chat.id)"
        ></chat-list-item>
      </ul>
    </section>
    <section class="chat-section all-chats mb-0 d-md-none">
      <ul class="chat-list">
        <chat-list-item
          v-for="chat of dataChatRoom"
          :key="chat.id"
          :chat="chat"
          :isActive="chat.id === activeChatId"
          @click.native="selectChat(chat.id)"
        ></chat-list-item>
      </ul>
    </section>
  </div>
</template>

<script>
import ChatListItem from './ChatListItem'
import { mapActions, mapState } from 'vuex'
import { ChatMixin } from '@/mixins/chat'
import ChatSearch from '../ChatSearch/ChatSearch'
// import { chatRoom } from '../../chatData'
import axios from 'axios'

export default {
  name: 'ChatList',
  components: { ChatSearch, ChatListItem },
  mixins: [ChatMixin],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      userData: JSON.parse(localStorage.getItem('userPengendalian') || {}),
      search: '',
      dataChatRoom: [],
    }
  },
  computed: {
    ...mapState('chat', ['user', 'chats', 'activeChatId']),
  },
  methods: {
    ...mapActions('chat', ['setActiveChat']),
    async loadChatRoom() {
      const res = await axios.get(`${this.baseapiPengendalian}api/chat_room?limit=0`, this.getApiOption())
      this.dataChatRoom = res.data?.data || []
    },
    selectChat(id_chat_room) {
      this.setActiveChat(id_chat_room)
      const activeChat = this.$route.query.id_chat_room
      if (activeChat != id_chat_room) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, id_chat_room },
        })
      }
    },
    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.userData.accessToken,
        },
        ...option,
      }
    },
  },
  async mounted() {
    await this.loadChatRoom()
    // this.dataChatRoom = [...chatRoom]
  },
}
</script>

<style src="./ChatList.scss" lang="scss" scoped></style>
